import type { LeaderboardEntryWire, LeaderboardResponseWire } from '../schemas/leaderboard';
import type { LeaderboardEntry, LeaderboardResponse } from '@/types/leaderboard';

export function mapLeaderboardEntryWireToDomain(
  wire: LeaderboardEntryWire,
): LeaderboardEntry {
  return {
    rank: wire.rank,
    userId: wire.user_id,
    username: wire.username,
    displayName: wire.display_name,
    avatarUrl: wire.avatar_url,
    count: wire.count,
  };
}

export function mapLeaderboardResponseWireToDomain(
  wire: LeaderboardResponseWire,
): LeaderboardResponse {
  return {
    category: wire.category,
    entries: wire.entries.map(mapLeaderboardEntryWireToDomain),
    currentUser: mapLeaderboardEntryWireToDomain(wire.current_user),
  };
}
